import { render } from "./easteregg-clippy.vue?vue&type=template&id=2075cea8&ts=true"
import script from "./easteregg-clippy.ts?vue&type=script&lang=ts&external"
export * from "./easteregg-clippy.ts?vue&type=script&lang=ts&external"

import "./easteregg-clippy.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__